import { catchError, of, Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Component, Input, ChangeDetectorRef } from '@angular/core';

import { InternalProductWithRatingsWithFavoriteStatusType } from '@sifca-monorepo/ecommerce-generator';

import { AppService, AuthService, SharedService } from '../../../services';
import { OrdersService } from '../../../services/order/order/order.service';
import { map } from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Component({
  template: '',
})
export class BaseProductInListComponent {
  private unsubscribeAll: Subject<any> = new Subject<any>();

  @Input() product: InternalProductWithRatingsWithFavoriteStatusType;
  @Input() isDragging: boolean;

  posId: string = '';
  isOutOfStock: boolean;
  authenticated: boolean;
  isButtonDisabled = false;

  constructor(
    protected appService: AppService,
    protected authService: AuthService,
    protected orderService: OrdersService,
    protected translate: TranslateService,
    protected toastrService: ToastrService,
    protected sharedService: SharedService,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {
    this.sharedService.posId$.subscribe((posId) => {
      this.posId = posId;
    });
    this.authService.authenticated$.subscribe((authenticated: boolean) => {
      this.authenticated = authenticated;
      this.changeDetectorRef.markForCheck();
    });
  }

  addToCart(product: InternalProductWithRatingsWithFavoriteStatusType) {
    this.isButtonDisabled = true;
    this.appService
      .getStockByTargetAndBarcode(product.barcodes[0].id)
      .pipe(
        catchError(() => {
          this.isOutOfStock = true;
          this.toastrService.error('Le produit est en rupture de stock !');
          return of(null);
        }),
      )
      .subscribe((res) => {
        if (res) {
          this.isOutOfStock = res.outOfStock;
          if (this.isOutOfStock === true) {
            this.toastrService.error('Le produit est en rupture de stock !');
          } else {
            if (!this.authenticated) {
              if (this.appService.itemInCart(product.barcodes[0])) {
                const value: any = {
                  barcode: { ...product.barcodes[0], internalProduct: { spces: product?.specs } },
                  price: {
                    unitGross: product.barcodes[0].price,
                    gross: product.barcodes[0].price,
                  },
                  product,
                  quantity: 1,
                };
                this.appService.updateLocalCart(value);
              } else {
                const value: any = {
                  barcode: product.barcodes[0],
                  price: {
                    unitGross: product.barcodes[0].price,
                    gross: product.barcodes[0].price,
                  },
                  product,
                  quantity: 1,
                };
                this.appService.addToLocalCart(value);
                // this.allProducts = map(this.products, (product) => ({
                //   quantity: product.quantity,
                //   barcode: product?.barcode?.id,
                // }));
                // this.orderService
                //   .calculateShoppingCart(this.allProducts)
                //   .pipe(catchError(() => of(null)))
                //   .subscribe();
              }
              this.appService.items$.pipe(takeUntil(this.unsubscribeAll)).subscribe((products: any[]) => {
                const allProducts = map(products, (product) => ({
                  quantity: product.quantity,
                  barcode: product?.barcode?.id,
                }));
                this.orderService.calculateShoppingCart(allProducts).subscribe();
                this.changeDetectorRef.markForCheck();
              });
              this.toastrService.success('Produit ajouté au panier.');
              this.isButtonDisabled = false;
            } else {
              const formValue = {
                barcode: product.barcodes[0].id,
                quantity: 1,
              };
              this.orderService
                .addProductsToCart([formValue])
                .pipe(
                  catchError(() => {
                    this.toastrService.error("Quelque chose s'est mal passé");
                    return of(null);
                  }),
                )
                .subscribe((res) => {
                  if (res) {
                    this.toastrService.success('Produit ajouté au panier.');
                    this.isButtonDisabled = false;
                  }
                });
              this.appService.loadCart();
            }
          }
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
